import React, { Component } from "react";
import Base from "../Common/Components/Base";
const SalesComponent = () => {
  return (
    <Base>
      <div>sales component !!</div>
    </Base>
  );
};

export default SalesComponent;
